import { checkInProgress } from './checkInModel';

/** Seats checked in so far, as a count and a bar. */
export function CheckInProgress({
  checkedInSeats,
  confirmedAttendees,
}: {
  checkedInSeats: number;
  confirmedAttendees: number;
}) {
  const { toGo, percent: pct } = checkInProgress(checkedInSeats, confirmedAttendees);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--nb-ink)' }}>
          {checkedInSeats} <span style={{ color: 'var(--nb-subtle)' }}>/ {confirmedAttendees}</span>{' '}
          <span style={{ fontSize: 12.5, fontWeight: 500, color: 'var(--nb-subtle)' }}>
            guests in
          </span>
        </span>
        <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>{toGo} to go</span>
      </div>
      <div
        className="nb-bar"
        style={{ width: '100%' }}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={`${checkedInSeats} of ${confirmedAttendees} guests in`}
      >
        <i style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
